import React from 'react';

import ReactDOM from 'react-dom';

import { AnimatePresence } from 'framer-motion';

import * as Styles from './ToastStyles';

import { ToastWrapperProps } from './interfaces';

import Toast from './Toast';

const ToastWrapper: React.FC<ToastWrapperProps> = ({ toasts }) => {
  /* * Hooks */

  return ReactDOM.createPortal(
    <Styles.Wrapper>
      <AnimatePresence>
        {toasts.map(({ id, ...rest }) => (
          <Toast key={`toast-${id}`} id={id} {...rest} />
        ))}
      </AnimatePresence>
    </Styles.Wrapper>,
    document.body,
  );
};

export default ToastWrapper;
